import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import WAppContainer from './app-container'
import WBarCode from './bar-code'
import WCollapse from './collapse'
import WDailog from './dialog'
import { WindDragContainer, WindDragItem, initDrag } from './drag'
import WIcon from './icon'
import WImage from './image'
import WImagePreview from './image-preview'
import WIndexList from './index-list'
import WInput from './input'
import WInputNumber from './input-number'
import WLink from './link'
import WLoading from './loading'
import WPagination from './pagination'
import WPasswordInput from './password-input'
import WPopover from './popover'
import WQrCode from './qr-code'
import WScrollBar from './scroll-bar'
import WSelect from './select'
import WSelectCycle from './select-cycle'
import WSelectMulity from './select-mulity'
import WSelectTab from './select-tab'
import WSelectTabMulity from './select-tab-mulity'
import { WindTable, WindTableColumn } from './simple-table'
import WSwitch from './switch'
import WTabs from './tabs'
import WTag from './tag'
import WTree from './tree'
import WTreeVirtual from './tree-virtual'
import WUpload from './upload'
import WValidate from './validate'
import WYearStepper from './year-stepper'
import { WindVirtualTable, WindVirtualTableColumn } from './virtualTable'
import WRenderDom from './render-dom'
// plugin
import WConfirm from './confirm'
import WContextMenu from './context-menu'
import WMessage from './message'
import WUploadHide from './upload-hide'
import scrollHide from './js/utils/scroll-hide.js'
// style
import './theme/index.scss'


const install = function (Vue) {
	Vue.use(ElementUI, { size: 'small' })
	Vue.component('w-app-container', WAppContainer)
	Vue.component('w-barcode', WBarCode)
	Vue.component('w-collapse', WCollapse)
	Vue.component('w-dialog', WDailog)
	Vue.component('w-drag-container', WindDragContainer)
	Vue.component('w-drag-item', WindDragItem)
	Vue.component('w-icon', WIcon)
	Vue.component('w-image', WImage)
	Vue.component('w-image-preview', WImagePreview)
	Vue.component('w-index-list', WIndexList)
	Vue.component('w-input', WInput)
	Vue.component('w-input-number', WInputNumber)
	Vue.component('w-link', WLink)
	Vue.component('w-pagination', WPagination)
	Vue.component('w-password-input', WPasswordInput)
	Vue.component('w-popover', WPopover)
	Vue.component('w-qr-code', WQrCode)
	Vue.component('w-scroll-bar', WScrollBar)
	Vue.component('w-select', WSelect)
	Vue.component('w-select-cycle', WSelectCycle)
	Vue.component('w-select-mulity', WSelectMulity)
	Vue.component('w-select-tab', WSelectTab)
	Vue.component('w-select-tab-mulity', WSelectTabMulity)
	Vue.component('w-simple-table', WindTable)
	Vue.component('w-simple-table-column', WindTableColumn)
	Vue.component('w-switch', WSwitch)
	Vue.component('w-tabs', WTabs)
	Vue.component('w-tag', WTag)
	Vue.component('w-tree', WTree)
	Vue.component('w-tree-virtual', WTreeVirtual)
	Vue.component('w-upload', WUpload)
	Vue.component('w-validate', WValidate)
	Vue.component('w-year-stepper', WYearStepper)
	Vue.component('w-virtual-table', WindVirtualTable)
	Vue.component('w-virtual-table-column', WindVirtualTableColumn)
	Vue.component('fx-render-dom', WRenderDom)
	// plugin
	Vue.use(WConfirm)
	Vue.use(WContextMenu)
	Vue.use(WMessage)
	Vue.use(WUploadHide)
	Vue.use(WLoading)
	scrollHide.init()
	initDrag(Vue)
}

// 注入 Vue
if (typeof window.Vue !== 'undefined' && window.Vue) {
	install(window.Vue)
}

export default {
	install
}
